import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-up-circle",
  "use": "icon-arrow-up-circle-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" id=\"icon-arrow-up-circle\"><circle cx=\"10\" cy=\"10\" r=\"10\" /><path d=\"M6 12l4.12-4L14 12\" stroke-width=\"2\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol